import React, { forwardRef } from 'react'
import emphasizeAmpersand from 'src/helpers/emphasizeAmpersand'

interface IH3Props {
  firstPart: string
  secondPart: string
  className?: string
  variant?: 'default' | 'inverse'
}

const H3 = forwardRef<HTMLHeadingElement, IH3Props>(
  ({ firstPart, secondPart, className = '', variant = 'default' }, ref) => {
    const isInverse = variant === 'inverse'
    const firstColor = isInverse ? 'text-on-surface-inverse dark:text-on-surface-dark' : 'text-black dark:text-white'
    const secondColor = isInverse ? 'text-on-surface-inverse dark:text-on-surface-dark' : 'text-red'

    return (
      <h3
        ref={ref}
        className={`font-palanquinDark text-headline-small md:text-headline-large font-bold ${className}`}
      >
        <span className={`block ${firstColor}`}>
          {emphasizeAmpersand(firstPart, 1.1)}
        </span>
        {secondPart ? (
          <span className={`block ${secondColor} -mt-pico md:-mt-extra-small`}>
            {emphasizeAmpersand(secondPart, 1.1)}
          </span>
        ) : null}
      </h3>
    )
  }
)

H3.defaultProps = {
  className: '',
  variant: 'default',
}

export default H3
